import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';

const ProductCard = ({ product, index }) => {
  return (
    <Link to={`/products/${product.id}`} data-testid={`product-card-${index}`}>
      <div className="product-card bg-white rounded-2xl shadow-lg overflow-hidden group">
        <div className="aspect-square overflow-hidden relative">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
          {product.featured && (
            <span className="absolute top-4 right-4 bg-gradient-to-r from-amber-400 to-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full">
              Featured
            </span>
          )}
          {product.original_price && (
            <span className="absolute top-4 left-4 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full">
              Sale
            </span>
          )}
        </div>
        <div className="p-4">
          <h3 className="font-semibold text-lg mb-2 line-clamp-1" data-testid={`product-name-${index}`}>
            {product.name}
          </h3>
          <p className="text-gray-600 text-sm mb-3 line-clamp-2">{product.description}</p>
          
          <div className="flex items-center gap-1 mb-3">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className={`w-4 h-4 ${i < Math.floor(product.rating) ? 'text-amber-400 fill-amber-400' : 'text-gray-300'}`}
              />
            ))}
            <span className="text-xs text-gray-500 ml-1">({product.reviews_count})</span>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-2xl font-bold text-pink-600" data-testid={`product-price-${index}`}>
              ₹{product.price}
            </span>
            {product.original_price && (
              <span className="text-sm text-gray-400 line-through">
                ₹{product.original_price}
              </span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;